import React, { useState } from 'react';
import {
  Box,
  Button,
  Image,
  ListItem,
  Stack,
  Text,
  UnorderedList,
  VStack,
} from '@chakra-ui/react';

import { Company, ContactUs, IMG, Menu, Service } from '../../Content/Content';
import { NavLink, useNavigate } from 'react-router-dom';
import { AiOutlineMenu, AiFillCloseCircle } from 'react-icons/ai';
function Footer() {
  return (
    <VStack borderTop="1px solid rgba(0, 0, 0, 0.49)" w="100%">
      <Stack width="90%" paddingY="50px">
        <Stack
          className="footer-area"
          display="flex "
          justifyContent="space-between"
          flexDirection="row"
        >
          <Box w="50%">
            <Image src={IMG.logo} h="145px"/>
          </Box>
          <Box
            w="50%"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box className="services">
              <UnorderedList
                display="flex"
                alignItems="start"
                justifyContent="center"
                flexDirection="column"
              >
                <ListItem listStyleType="none">
                  {' '}
                  <Text
                    fontStyle="normal"
                    fontWeight="600"
                    fontSize="24px"
                    lineHeight="36px"
                    color="#000000"
                  >
                    Services
                  </Text>
                </ListItem>
                {Service.map((item, index) => {
                  return (
                    <ListItem
                      key={index}
                      listStyleType={'none'}
                      padding={'12px 15px'}
                      margin={'0 10px'}
                      textTransform="capitalize"
                      className="nav-item"
                    >
                      <NavLink to={item.url}>
                        <Text
                          fontStyle="normal"
                          fontWeight="400"
                          fontSize="22px"
                          lineHeight="36px"
                          color="#000000"
                        >
                          {' '}
                          {item.name}
                        </Text>
                      </NavLink>
                    </ListItem>
                  );
                })}
              </UnorderedList>
            </Box>
            <Box className="company">
              <UnorderedList
                display="flex"
                alignItems="start"
                justifyContent="center"
                flexDirection="column"
              >
                <ListItem listStyleType="none">
                  {' '}
                  <Text
                    fontStyle="normal"
                    fontWeight="600"
                    fontSize="24px"
                    lineHeight="36px"
                    color="#000000"
                  >
                    Company
                  </Text>
                </ListItem>
                {Company.map((item, index) => {
                  return (
                    <ListItem
                      key={index}
                      listStyleType={'none'}
                      padding={'12px 15px'}
                      margin={'0 10px'}
                      textTransform="capitalize"
                      className="nav-item"
                    >
                      <NavLink to={item.url}>
                        <Text
                          fontStyle="normal"
                          fontWeight="400"
                          fontSize="22px"
                          lineHeight="36px"
                          color="#000000"
                        >
                          {' '}
                          {item.name}
                        </Text>
                      </NavLink>
                    </ListItem>
                  );
                })}
              </UnorderedList>
            </Box>
            <Box className="contactUs">
              <UnorderedList
                display="flex"
                alignItems="start"
                justifyContent="center"
                flexDirection="column"
              >
                <ListItem listStyleType="none">
                  {' '}
                  <Text
                    fontStyle="normal"
                    fontWeight="600"
                    fontSize="24px"
                    lineHeight="36px"
                    color="#000000"
                  >
                    Contact Us
                  </Text>
                </ListItem>
                {ContactUs.map((item, index) => {
                  return (
                    <ListItem
                      key={index}
                      listStyleType={'none'}
                      padding={'12px 15px'}
                      margin={'0 10px'}
                      textTransform="capitalize"
                      className="nav-item"
                    >
                      <NavLink to={item.url}>
                        <Text
                          fontStyle="normal"
                          fontWeight="400"
                          fontSize="22px"
                          lineHeight="36px"
                          color="#000000"
                        >
                          {' '}
                          {item.name}
                        </Text>
                      </NavLink>
                    </ListItem>
                  );
                })}
              </UnorderedList>
            </Box>
          </Box>
        </Stack>
      </Stack>
    </VStack>
  );
}

export default Footer;
